<template>
   <div class="featurePage">
      <div class="dowebok">
          <div>
              <div class="top">
                <div class="title1 cicleCenter">Create Customized Space Powered by Text to 3D AI</div>
                <div class="title2 cicle">Create Customized Space Powered by Text to 3D AI</div>
                <div class="title3 cicle">Create Customized Space Powered by Text to 3D AI</div>
                <div class="subTitle">Create Customized Space Powered by Text to 3D AI</div>
                <!-- <img  src="../assets/ciclebg.png"/> -->
                <div class="line"></div>
              </div>
                <div class="swiper-content mask1">
                    <div class="swiper-container">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" data-title="Text to 3D" data-subtitle="Create Customized World Powered by Generative AI">
                          <div class="video_mask" ></div>
                          <video  class="video_item" width="100%" autoplay muted loop webkit-playsinline="true" playsinline="true">
                            <source src="../assets/video/feature_01.mp4" type="video/mp4">
                            <source src="../assets/video/feature_01.mp4" type="video/ogg">
                            <source src="../assets/video/feature_01.mp4" type="video/webm">
                            <object data="../assets/video/feature_01.mp4">
                              <embed src="../assets/video/feature_01.mp4">
                            </object>
                          </video>
                        </div>
                        <div class="swiper-slide" data-title="Earn WorldKey Tokens" data-subtitle="Collect Countless Tokens by Upgrading Your Home">
                          <div class="video_mask" ></div>
                          <video  class="video_item" width="100%" autoplay muted loop webkit-playsinline="true" playsinline="true">
                            <source src="../assets/video/feature02_upgrade.mp4" type="video/mp4">
                            <source src="../assets/video/feature02_upgrade.mp4" type="video/ogg">
                            <source src="../assets/video/feature02_upgrade.mp4" type="video/webm">
                            <object data="../assets/video/feature02_upgrade.mp4">
                              <embed src="../assets/video/feature02_upgrade.mp4">
                            </object>
                          </video>
                        </div>
                        <div class="swiper-slide" data-title="Explore Life Simulation" data-subtitle="Unlock Unlimited Possibilities from Gaming, Working and Social Network">
                          <div class="video_mask" ></div>
                          <video  class="video_item" width="100%" autoplay muted loop webkit-playsinline="true" playsinline="true">
                            <source src="../assets/video/feture_03.mp4" type="video/mp4">
                            <source src="../assets/video/feture_03.mp4" type="video/ogg">
                            <source src="../assets/video/feture_03.mp4" type="video/webm">
                            <object data="../assets/video/feture_03.mp4">
                              <embed src="../assets/video/feture_03.mp4">
                            </object>
                          </video>
                        </div>
                      </div>
                    </div>
                </div>
          </div>
      </div>

      <div class="mobileFeature">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                   <div class="sub-title titleMg">
                     <div>Text to 3D</div>
                     <div>Create Customized World Powered by Generative AI</div>
                   </div>
                   <div class="centerIcon"><img  src="../assets/icon_dashpoint.svg"/></div>
                   <div class="featureVideo">
                      <video width="100%" ref="video1" autoplay="true" loop="true" muted webkit-playsinline="true" playsinline="true" >
                      <source  src="../assets/video/feature_01.mp4" />
                      Your browser does not support the video tag.
                    </video>
                   </div>
                   <div class="arrowUp"><img  src="../assets/icon_arrow.svg"/></div>

                   <div class="nextContent">
                      <div class="sub-title titleMg2">
                        <div>Earn WorldKey Tokens</div>
                        <div>Collect Countless Tokens by Upgrading Your Home</div>
                      </div>
                      <div class="centerIcon"><img  src="../assets/icon_dashpoint.svg"/></div>
                      <div class="featureVideo">
                          <img src="../assets/feature02_upgrade.jpg"/>
                      </div>
                      <div class="mask"></div>
                   </div>
                </div>
                <div class="swiper-slide">
                  <div class="sub-title titleMg">
                      <div>Earn WorldKey Tokens</div>
                      <div>Collect Countless Tokens by Upgrading Your Home</div>
                   </div>
                   <div class="centerIcon"><img  src="../assets/icon_dashpoint.svg"/></div>
                   <div class="featureVideo">
                      <video width="100%" ref="video2" autoplay="true" loop="true" muted webkit-playsinline="true" playsinline="true" >
                      <source  src="../assets/video/feature02_upgrade.mp4" />
                      Your browser does not support the video tag.
                    </video>
                   </div>
                   <div class="arrowUp"><img  src="../assets/icon_arrow.svg"/></div>

                   <div class="nextContent">
                      <div class="sub-title titleMg2">
                       <div>Explore Life Simulation</div>
                        <div>Unlock Unlimited Possibilities from Gaming, Working and Social Network</div>
                      </div>
                      <div class="centerIcon"><img  src="../assets/icon_dashpoint.svg"/></div>
                      <div class="featureVideo">
                           <img src="../assets/explore_done.jpg"/>
                      </div>
                      <div class="mask"></div>
                   </div>
                </div>
                <div class="swiper-slide">
                    <div class="sub-title titleMg">
                     <div>Explore Life Simulation</div>
                     <div>Unlock Unlimited Possibilities from Gaming, Working and Social Network</div>
                   </div>
                   <div class="centerIcon"><img  src="../assets/icon_dashpoint.svg"/></div>
                   <div class="featureVideo">
                      <video ref="video3"  width="100%" autoplay="true" loop="true" muted webkit-playsinline="true" playsinline="true">
                      <source  src="../assets/video/feture_03.mp4" />
                      Your browser does not support the video tag.
                    </video>
                   </div>
                   <div ref="arrowUp" class="arrowUp rotationAnima"><img  src="../assets/icon_arrow.svg"/></div>

                   <div ref="endIcon" class="nextContent featureEnd opacityAnima">
                      <div>Thanks for following WorldKey</div>
                      <div>©2026 WorldKey. All Rights Reserved</div>
                   </div>
                </div>
            </div>
        </div>
      </div>
   </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper } from 'vue-awesome-swiper'
export default {
  name: 'Feature',
  data () {
    return {
      allPageHeight: document.body.clientHeight - 70,
      preVideo: null,
      isWeixin: false
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
    if (this.isMobileFn()) {
      this.initDataMoible()
    } else {
      this.initData()
    }
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.$refs.video1.controls = 'controls'
      this.$refs.video2.controls = 'controls'
      this.$refs.video3.controls = 'controls'
    }
  },
  methods: {
    isMobileFn () {
      var userAgentInfo = navigator.userAgent
      var mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone']
      var mobile_flag = false
      // 根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true
          break
        }
      }

      return mobile_flag
    },
    initDataMoible () {
      console.log('dddddddddddddddddddddddd')
      let _this = this
      var swiper = new Swiper('.swiper', {
        direction: 'vertical', // 垂直切换选项
        autoplay: false,
        loop: false,
        initialSlide: 0,
        spaceBetween: 20,
        width: window.innerWidth,
        height: window.innerHeight,
        on: {
          slideChangeTransitionStart () {
            _this.$refs.endIcon.style.display = 'none'
            _this.$refs.arrowUp.style.display = 'none'
          },
          slideChangeTransitionEnd: function (swiper) {
            _this.$refs.endIcon.style.display = 'block'
            _this.$refs.arrowUp.style.display = 'block'
          }
        }
      })
    },
    initData () {
      this.stopAll()
      let _this = this
      var swiper = new Swiper('.swiper-container', {
        autoplay: false,
        loop: true,
        initialSlide: 0,
        spaceBetween: 20,
        centeredSlides: true,
        slidesPerView: 1.4,
        loopAdditionalSlides: 50,
        on: {
          slideChangeTransitionEnd: function () {
            _this.stopAll()
            var video = document.querySelector('.swiper-slide-active').children[1]
            var dom = video.previousElementSibling
            dom.style.display = 'none'
            video.play()
            _this.preVideo = document.querySelector('.swiper-slide-active').previousElementSibling.children[1]
            document.querySelector('.title1').innerHTML = document.querySelector('.swiper-slide-active').dataset.title
            document.querySelector('.title2').innerHTML = document.querySelector('.swiper-slide-active').nextElementSibling.dataset.title
            document.querySelector('.title3').innerHTML = document.querySelector('.swiper-slide-active').previousElementSibling.dataset.title
            document.querySelector('.subTitle').innerHTML = document.querySelector('.swiper-slide-active').dataset.subtitle
          }
        }
      })
    },
    stopAll () {
      let videolist = document.querySelectorAll('.video_item')
      for (let i = 0; i < videolist.length; i++) {
        videolist[i].pause()
      }
      let maskList = document.querySelectorAll('.video_mask')
      for (let i = 0; i < maskList.length; i++) {
        maskList[i].style.display = 'block'
      }
    },
    scrollFn () {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop
      document.querySelector('.topCicleImg').style.top = this.imgTop + scroll / 1.5 + 'px'
    }
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 767px) {

  .featurePage {
    position:relative;
  }
  .featurePage:after{
     content: " ";
     width:100%;
     height:100%;
     top:0;
     left:0;
     position:absolute;
     background:url("../assets/h5_feature_bg.png");
     background-size:100% auto;
     opacity: 0.15;
  }
  .dowebok{
    display:none;
  }
  body, html{
    overflow:hidden !important;
    height: 100%;
  }
  .mobileFeature{
    display:block;
    overflow:hidden;
    height: 100%;
  }
  .swiper,.swiper-wrapper {
     overflow:hidden;
    height: 100%;
  }
  .swiper,.swiper-slide{
    width:100%;
    height:100%;
  }
  .nextContent{
    position:relative;
  }
  .mask{
    position:absolute;
    z-index:2;
    width:100%;
    height:100%;
    background: linear-gradient(180deg, rgba(3, 2, 2, 0.15) 0%, #020202 100%);
    top:0;
  }
  .swiper-slide {
      overflow: hidden;
  }
  .featureEnd {
    margin-top:70px;
    opacity: 0;
    >div:nth-child(1){
      color: #EBEBEB;
      text-align: center;
      text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 134%;
    }
    >div:nth-child(2) {
      color: #8A8A8A;
      text-align: center;
      text-shadow: 0px 1.5px 3px rgba(0, 0, 0, 0.30);
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 134%;
    }
  }
  .sub-title{
    padding-left:40px;
    position:relative;
    >div:nth-child(1) {
      color: #FFF;
      text-shadow: 0px 1.5px 3px rgba(0, 0, 0, 0.30);
      font-size: 22px;
      font-style: normal;
      font-family: "EncodeSans-Bold";
      font-weight: 700;
      line-height: 128%; /* 28.16px */
    }
    >div:nth-child(2) {
      margin-top:10px;
      color: #E5E5E5;
      text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 134%; /* 17.42px */
      padding-right:30px;
    }
  }
  .sub-title:after{
    content:" ";
    position:absolute;
    width:14px;
    height:41px;
    left:0px;
    top:0px;
    background:url("../assets/titleIcon.png");
    background-size: 100% 100%;
    z-index:3;
  }
  .titleMg{
    margin-top:109px;
  }
  .titleMg2{
    margin-top:45px;
  }
  .featureVideo{
    margin:0 8px;
    border-radius: 8px;
    overflow: hidden;
    video{
      border-radius: 8px;
    }
    img {
      width:100%;
    }
  }
  .centerIcon{
    text-align: center;
    margin-top:6px;
    margin-bottom:4px;
  }
  .arrowUp{
    text-align: center;
    margin-top:30px;
  }
}
@media (min-width: 768px) {
  .dowebok{
    display:block;
  }
   .mobileFeature{
    display:none;
  }
  .featurePage {
   width:100%;
   height:calc(~"100% - 135px");
   position:relative;
 }
}
 .top{
   position:absolute;
   z-index:100;
   width:100%;
   height:175px;
   text-align: center;
   top:20px;
   background: url("../assets/ciclebg.png") no-repeat;
   background-size:100% 100%;
   img {
     width:100%;
     height:100%;
   }
 }

 .title1 {
    position:absolute;
    font-size:26px;
    width:452px;
    left:50%;
    transform: translateX(-50%);
    bottom:45px;
    font-family: "EncodeSans-Bold";
    padding-bottom:30px;
  }
  .subTitle {
    position:absolute;
    font-size:18px;
    width:716px;
    left:50%;
    transform: translateX(-50%);
    bottom:45px;
    color: #F6F6F6;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .title2{
    position:absolute;
    width:285px;
    bottom:49%;
    right:1%;
    font-size:20px;
    font-family: "EncodeSans-Bold";
    color: #E9E9E9;
  }
  .title3{
    position:absolute;
    width:285px;
    bottom:49%;
    left:1%;
    font-size:20px;
    font-family: "EncodeSans-Bold";
    color: #E9E9E9;
  }
 .cicle::after{
    content: " ";
    width:10px;
    height:10px;
    position:absolute;
    left:50%;
    transform: translateX(-50%);
    background:#fff;
    border-radius: 50%;
    bottom:-22px;
    opacity: 0.3;
 }
 .cicleCenter::after {
   content: " ";
    width:12px;
    height:12px;
    position:absolute;
    left:50%;
    transform: translateX(-50%);
    background:#fff;
    border-radius: 50%;
    bottom:-23px;
    opacity: 0.9;
 }
 .dowebok {

   >div{
     position:absolute;
     width:80%;
     left:10%;
     top:46%;
     transform:translateY(-50%);
     z-index:12;
   }
 }

.dowebok::after {   // div是你需要添加背景图片的盒子
    content: " ";
    background:url("../assets/web_bg1.png");
    position: absolute;
    width:100%;
    height:100%;
    filter: blur(1px);
    left: 0;
}
 .swiper-container {
      width: 100%;
      height: 100%;
      // border-bottom-right-radius:30%;
      // border-bottom-left-radius:30%;
      overflow: hidden;
      margin-top:100px;
      position:relative;
      .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      background:none;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      position:relative;
      video{
        background:none;
      }
      .video_mask{
        background:#000000;
        width:100%;
        opacity: 0.4;
        position:absolute;
        width:100%;
        height:100%;
      }

    }
    .swiper-slide img {
      width: 100%;
      height: 100%;
    }

    .swiper-container-horizontal>.swiper-pagination-bullets {
      bottom: 0;
    }
    .swiper-pagination {
      position: relative;
    }
}
.opacityAnima{
    animation: opacityAnimation 0.5s ease 0s forwards;
}
.rotationAnima{
   animation: rotationAnimation 0.5s ease 0s forwards;
}
@keyframes rotationAnimation {
  to {
    transform: rotate(180deg);
  }
}
@keyframes opacityAnimation {
  from {
    opacity: 0;
  }
  100%,
  to {
    opacity: 1;
  }
}
.mask1 {
        -webkit-mask-image: url(../assets/svg/Mask.svg);
        mask-image: url(../assets/svg/Mask.svg);
        mask-repeat: no-repeat;
        mask-size: 100% auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Feature.vue